import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import * as auth from "@/store/modules/auth";
import * as caption from "@/store/modules/caption";
import * as lookups from "@/store/modules/lookups";
import * as catalog from "@/store/modules/catalog";
import * as institutions from "@/store/modules/institutions";
import {isEmpty} from "@/util/Helpers";
import catalogIndexedDbPlugin from "@/store/plugins/catalogIndexedDbPlugin";


Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        sub1: {
            Theme: "light", // theme can be light or dark
            LayoutType: "full-sidebar", // this can be full-sidebar, mini-sidebar
            Sidebar_drawer: false,
            Customizer_drawer: false,
            SidebarColor: "dark", //Change Sidebar Color || 'white', | "#2b2b2b" | "rgb(44, 59, 164)" | "rgb(96, 44, 164)" | "rgb(151, 210, 219)" | "rgb(77, 86, 100)"
            navbarColor: "primary-sub1",
            logoColor: "primary-sub1",
            setHorizontalLayout: false, // Horizontal layout
            Direction: "ltr", // possible value  rtl / ltr
            hasUnsavedChanges: false, // if any change become on state isDirty is true.
            isBusy: false,
            isValid: true
        }
    },
    mutations: {
        IS_VALID(state, payload) {
            // if ((payload.isUpdated && payload.isValid !== state.isValid) || (payload.isUpdated === payload.isValid && payload.isValid === false))
            state.sub1.isValid = payload.isValid;
        },
        IS_BUSY(state, payload) {
            state.sub1.isBusy = payload;
        },
        SET_THEME(state, payload) {
            state.sub1.Theme = payload;
        },
        SET_LAYOUT_TYPE(state, payload) {
            if (!isEmpty(payload)) {
                state.sub1.LayoutType = payload;
            }
            state.sub1.setHorizontalLayout = false
        },
        SET_SIDEBAR_DRAWER(state, payload) {
            state.sub1.Sidebar_drawer = payload;
        },
        SET_CUSTOMIZER_DRAWER(state, payload) {
            state.sub1.Customizer_drawer = payload;
        },
        SET_SIDEBAR_COLOR(state, payload) {
            state.sub1.SidebarColor = payload;
        },
        SET_NAVBAR_COLOR(state, payload) {
            state.sub1.navbarColor = payload;
        },
        SET_LOGO_COLOR(state, payload) {
            state.sub1.logoColor = payload;
        },
        SET_LAYOUT(state, payload) {
            state.sub1.setHorizontalLayout = payload;
        },
        SET_DIRECTION(state, payload) {
            state.sub1.Direction = payload;
        },
        SET_HAS_UNSAVED_CHANGES(state, payload) {
            state.sub1.hasUnsavedChanges = payload;
        },
        SET_LOGOUT(state, dispatch) {
            dispatch('caption/resetState', {root: true})
            dispatch('auth/resetState', {root: true})
            state.sub1.hasUnsavedChanges = false
            state.sub1.isBusy = false
            state.sub1.isValid = true
            window.localStorage.clear();
        },
    },
    actions: {
        isValid({commit}, payload) {
            commit("IS_VALID", payload);
        },
        isBusy({commit}, isBusy) {
            commit("IS_BUSY", isBusy);
        },
        setLayoutType({commit}, width) {
            commit("SET_LAYOUT_TYPE", width);
        },
        hasUnsavedChanges({commit}, hasUnsavedChanges) {
            commit("SET_HAS_UNSAVED_CHANGES", hasUnsavedChanges);
        },
        logout({commit, dispatch}) {
            commit('SET_LOGOUT', dispatch)
        }
    },
    getters: {
        isBusy: (state) => state.sub1.isBusy,
        isValid: (state) => state.sub1.isValid
    },
    modules: {auth, caption, lookups, catalog, institutions},
    plugins: [
        createPersistedState({
        paths: ["sub1", "auth", "caption", "lookups", "institutions"],
    }),
    catalogIndexedDbPlugin,
    ],
});
